import firebase from "firebase/app";
import "firebase/firestore";

var firebaseConfig = {
    apiKey: "AIzaSyB6jA6pDfI_s2pTSUHYPcCPxUna7eocYpc",
    authDomain: "base-stations-otc-registration.firebaseapp.com",
    databaseURL: "https://base-stations-otc-registration.firebaseio.com",
    projectId: "base-stations-otc-registration",
    storageBucket: "base-stations-otc-registration.appspot.com",
    messagingSenderId: "946879709203",
    appId: "1:946879709203:web:3c1f50598e16ec4a56ffe6",
    measurementId: "G-D1SK0SSCRT"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
// firebase.analytics();

const db = firebase.firestore();

export default db;
